export enum ETicketType {
	SEASON_TICKET = "SEASON_TICKET",
	MATCH_TICKET = "MATCH_TICKET"
}
